import type { InvoiceRowData } from "@/components/shared/data-table";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import { confColor } from "@/lib/miscellaneous/confidence-color";
import { cn } from "@/lib/utils";
import type { CellContext } from "@tanstack/react-table";
import { formatInTimeZone } from "date-fns-tz";

type Props = CellContext<InvoiceRowData, unknown> & {
  showConfidence?: boolean;
};

export const StartDateCell = ({ row, showConfidence = false }: Props) => {
  if (
    row.original.invoice.status === InvoiceStatus.NEW ||
    row.original.invoice.status === InvoiceStatus.ERROR ||
    row.original.invoice.splitPdf === true ||
    !row.original.invoice.isBooking
  ) {
    return null;
  }

  const dateValue = row.original.invoice.serviceDate;

  const startDate = dateValue ? new Date(dateValue) : null;

  return (
    <div
      className={cn(
        "rounded h-auto w-auto p-1",
        confColor(
          showConfidence
            ? row.original.invoice.serviceDateConfidence
            : undefined,
        ),
      )}
    >
      {startDate
        ? formatInTimeZone(startDate, "Europe/Berlin", "dd.MM.yy")
        : "–"}
    </div>
  );
};
